var MapAnnuaire = (function(){
  'use strict';

  var centerMap = [4.86,45.76];
  var map = null;
  var bounds = [
    [4.39, 45.39], // Southwest coordinates
    [5.43, 46.14]  // Northeast coordinates
  ];
  var defaultZoom = 9;
  var minZoom = 9;
  var sourceName = "equipment";
  var popup = null;
  var isSingleMap = false;
  var idMap = "map-canvas";

  var getIdMap = function() {
    return idMap;
  };

  var getInfoBoxContent = function(marker) {
    var content = "";
    content += "<div class='directory-item--map'>";
    content += "<span class='directory-item__head' style=\"--poi-id: url('/" + marker.properties.iconUrl + "')\">" + marker.properties.city + "</span>";
    content += "<div class='directory-item__body'>";
    content += "<p>";
    content += marker.properties.name;
    content += "</p>";
    content += "<p>";
    content += marker.properties.address;
    content += "</p>";
    if(marker.properties.category !== '') {
      content += "<p>";
      content += marker.properties.category;
      content += "</p>";
    }
    content += "</div>";
    content += "<a href='"+  marker.properties.uri +"' title=\"Accéder à la fiche de l'équipement " + marker.properties.name + "\" class='directory-item__link'>+ d'infos ></a>";
    content += "</div>";

    return content;
  };

  var initClusterEvents = function() {
    map.on('click', 'clusters', function (e) {
      var features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
      var clusterId = features[0].properties.cluster_id;
      map.getSource(sourceName).getClusterExpansionZoom(clusterId, function (err, zoom) {
        if (err) {return;}

        map.easeTo({
          center: features[0].geometry.coordinates,
          zoom: zoom
        });
      });
    });

    map.on('mouseenter', 'clusters', function () {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', 'clusters', function () {
      map.getCanvas().style.cursor = '';
    });
  };

  var addPoiEvents = function() {
    map.on('click', 'equipment', function (e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var content = getInfoBoxContent(e.features[0]);

      popup.setLngLat(coordinates)
        .setHTML(content)
        .addTo(map);

      popup._closeButton.ariaLabel = "Fermer la fenêtre";
    });

    map.on('mouseenter', 'equipment', function () {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', 'equipment', function () {
      map.getCanvas().style.cursor = '';
    });
  };

  var loadLayer = function(){

    map.addSource(sourceName, {
      type: "geojson",
      data: equipments,
      cluster: true,
      clusterMaxZoom: 21,
      clusterRadius: 72
    });

    map.addLayer({
      'id': 'equipment',
      'type': 'symbol',
      'source': sourceName,
      'layout': {
        'icon-image': "{icon}",
        'icon-allow-overlap': true,
        'icon-padding': 0,
        'icon-anchor': "bottom",
        "visibility": "visible"
      }
    });

    map.addLayer({
      'id': 'clusters',
      'type': "circle",
      'source': sourceName,
      'filter': ["has", "point_count"],
      'layout': {
        "visibility": "visible"
      },
      'paint': {
        "circle-color": "#141b28",
        "circle-radius":15
      }
    });

    map.addLayer({
      'id': 'clusters-count',
      'type': "symbol",
      'source': sourceName,
      'filter': ["has", "point_count"],
      'layout': {
        "text-field": "{point_count_abbreviated}",
        //"text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
        "text-size": 12,
        "visibility": "visible"
      },
      'paint': {
        'text-color': '#ffffff'
      }
    });

    initClusterEvents();

    if(!isSingleMap) {
      addPoiEvents();
    }
  };

  return {
    getIdMap: getIdMap,
    init: function() {

      //si c'est une carte "Single"
      if($("#" + idMap).data("type") === "single"){
        isSingleMap = true;
        centerMap = equipments.features[0].geometry.coordinates;
        defaultZoom = 14;
      }

      map = new maplibregl.Map({
        container: idMap,
        style: "/typo3conf/ext/gl_portailvelo_template/Resources/Public/MapLibreStyles/vector.json",
        center: centerMap,
        zoom: defaultZoom,
        minZoom: minZoom,
        maxBounds: bounds,
        attributionControl: true,
        locale: {
          'NavigationControl.ZoomIn': 'Zoomer',
          'NavigationControl.ZoomOut': 'Dézoomer',
          'NavigationControl.ResetBearing': 'Modifier l\'orientation',
          'GeolocateControl.FindMyLocation': 'Afficher votre position'
        }
      });

      map.on('load', function() {

        //chargement des pictos de la carto
        if(typeof iconsMap !== "undefined"){
          var nbIcons = Object.keys(iconsMap).length;
          var nbIconsLoaded = 0;
          for (const iconName in iconsMap) {
            map.loadImage(iconsMap[iconName], (error, image) => {
              if (error) {
                throw error;
              }
              // Ajout de l'image chargé au sprite d'image
              map.addImage(iconName, image);

              nbIconsLoaded++;

              //on charge le layer quand tous les icônes sont chargés
              if(nbIconsLoaded === nbIcons){
                loadLayer();
              }
            });
          }
        }

        this.addControl(new maplibregl.AttributionControl({
          compact: false,
          customAttribution:
            '&copy; <a href="https://www.maptiler.com/copyright/" target="_blank" title="Accéder au site MapTiler (nouvelle fenêtre)">MapTiler</a>&nbsp;' +
            '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" title="Accéder au site OpenStreetMap (nouvelle fenêtre)">les contributeurs OpenStreetMap</a>'
        }), 'bottom-right');

        this.addControl(new maplibregl.NavigationControl({showCompass:true}), 'bottom-right');

        popup = new maplibregl.Popup({
          className: 'infobox map-infobox',
          maxWidth: '300px',
          closeOnClick: false
        });

        //mise à jour du aria-label du canvas
        if($('#' + idMap).data('arialabel')){
          $('.maplibregl-canvas').attr('aria-label', $('#' + idMap).data('arialabel'));
        }
      });
    }
  };

}());

$(document).ready(function(){

  if($("#" + MapAnnuaire.getIdMap()).length > 0) {
    MapAnnuaire.init();
    $('.js-mapDisplay').hide();
  }
});
